<!-- 质量水平 -->
<template>
  <div>
    <div class="title-content" style="display: flex;justify-content: space-between;align-items: center;">
      <div>{{ h_i18n('dc29a9159591189cda096cabe07980c8') }}</div>
      <!-- <h-button-new type="primary" @click="handleVersion" size="middle">切换旧版</h-button-new> -->
    </div>
    <h-list-page class="level-container">
      <!-- <h-button type="primary" @click="handleVersion">切换旧版</h-button> -->
      <div class="item-module">
        <div class="title-style">{{ h_i18n('e8162294c2299c48a18424268bf496c9') }}</div>
        <div class="btn-container">
          <div class="primary-btn" @click="handleDetail">{{ h_i18n('bc8a96444c0e3495d9042ebf356157a9') }}</div>
          <div class="primary-btn" style="margin-left: 12px;" @click="handleOrderDetail">{{ h_i18n('590668240abd2fbb992d3b4f7f31faf9') }}</div>
        </div>
        <el-table :empty-text="h_i18n('21efd88b67a39834582ad99aabb9dc60')" height="481" class="myTable"
          :data="specialTableData" size="small" style="width: 100%; min-height: 481px;border-radius: 8px;border:1px solid #E5E6EB;border-bottom: none !important;border-color:#E5E6EB !important;margin-top: 8px;"
          :header-cell-style="{ background: '#f1f2f8 !important' , color: '#1D2129' }">
          <el-table-column prop="pl" label="PL" width="100"></el-table-column>
          <el-table-column prop="groupname" :label="h_i18n('fac54c3430528339ac075d688db27ce8')"></el-table-column>
          <el-table-column prop="zyhnum" :label="h_i18n('a53a9389ecec772dc91c1de93b1d8b82')"></el-table-column>
          <el-table-column prop="dbnum" :label="h_i18n('8e9dbc8a072321ef32c04914d69ae3fc')"></el-table-column>
          <el-table-column prop="yjnum" :label="h_i18n('6d4036b80c89607a12928f1eba735c41')"></el-table-column>
          <el-table-column prop="xccbnum" :label="h_i18n('a00be2a1b06b15c78fc83ba6c8960476')"></el-table-column>
          <el-table-column prop="sccbnum" :label="h_i18n('f5d501327c171a0a2d846c380eabb0a6')"></el-table-column>
          <el-table-column prop="jtnum" :label="h_i18n('2b9112c58d2dab55271368749fda8ad3')" width="88"></el-table-column>
        </el-table>  
        <el-pagination background @current-change="handleSpecialPageChange"
          v-model:currentPage="specialCurrentPage" :page-size="10" style="display: flex;flex-direction: row;justify-content: flex-end;margin-right:50px;"
          layout="total, prev, pager, next,jumper" :total="specialTotal">
        </el-pagination>
      </div>
      <div class="item-module" style="margin-top: 12px;">
        <div class="title-style">{{ h_i18n('1927dac8abfef45780832d3409186a7e') }}</div>
        <div class="btn-container">
          <h-search :title="h_i18n('36a5d2e23d3454167254f10a406f059d')">
            <h-date-picker v-model="submitDate" type="daterange" :start-placeholder="h_i18n('592c59589144ddc68d05d528da17dcdc')" :end-placeholder="h_i18n('f782779e8b5d709462c8e71e0d9019f2')" clearable @change="handleSubmitDate"/>
          </h-search>
          <h-search :title="h_i18n('f1edca9f040d256cee01ef89fa5499f0')" style="margin-left: 4px;">
            <h-select v-model="searchData.zyh" clearable filterable>
              <template v-for="item in specialArray" :key="item">
                <h-option :label="item" :value="item"></h-option>
              </template>
            </h-select>
          </h-search>
          <div class="primary-btn" style="margin-left: 4px;" @click="getTripTable">{{ h_i18n('bee912d79eefb7335988c4997aa9138d') }}</div>
          <div class="reset-btn marginL12" @click="resetTable">{{ h_i18n('4b9c3271dc2f299dc3aeffb369187513') }}</div>
        </div>
        <el-table :empty-text="h_i18n('21efd88b67a39834582ad99aabb9dc60')" height="478" class="myTable"
          :data="tripTableData" size="small" style="width: 100%; min-height: 478px;border-radius: 8px;border:1px solid #E5E6EB;border-bottom: none !important;border-color:#E5E6EB !important;margin-top: -4px;"
          :header-cell-style="{ background: '#f1f2f8 !important' , color: '#1D2129' }">
          <el-table-column prop="pl" label="PL" width="100"></el-table-column>
          <el-table-column prop="groupname" :label="h_i18n('4e8365b7b7ef302d07d644229cb3055c')"></el-table-column>
          <el-table-column prop="groupcode" :label="h_i18n('f1edca9f040d256cee01ef89fa5499f0')" width="180"></el-table-column>
          <el-table-column :label="h_i18n('498bd05ebc689dfde8c4a3a59ace4a42')">
            <el-table-column prop="xcblnum" :label="h_i18n('111bf3546339b7d2a454e514828daf98')"></el-table-column>
            <el-table-column prop="xcbll" :label="h_i18n('5448436a1fb8cfb12a23eaf558378eb4')"></el-table-column>
          </el-table-column>
          <el-table-column :label="h_i18n('552cacb8043adc182c107be1712b7a79')">
            <el-table-column prop="scblnum" :label="h_i18n('111bf3546339b7d2a454e514828daf98')"></el-table-column>
            <el-table-column prop="scbll" :label="h_i18n('5448436a1fb8cfb12a23eaf558378eb4')"></el-table-column>
          </el-table-column>   
          <el-table-column prop="yjhnum" :label="h_i18n('3023c444773e59d5a95ee2395109d54f')"></el-table-column>
          <el-table-column prop="sjhnum" :label="h_i18n('2604650cae56276ebfcd86b49a8f5b66')"></el-table-column>
          <el-table-column prop="wjhnum" :label="h_i18n('1a88ac0ce7cda47b71f0703ade4b6d23')"></el-table-column>
          <el-table-column :label="h_i18n('91d5e5a8236e72af007dcfbf1e799b56')">
            <el-table-column prop="mkblnum" :label="h_i18n('f67f7d07d1512c4d64a97714706e1f9e')"></el-table-column>
            <el-table-column prop="fmkblnum" :label="h_i18n('0d80dc8935a9ed4221a6c2b06d1b460e')"></el-table-column>
          </el-table-column>
          <el-table-column :label="h_i18n('a3f5de49efbf59bc14f0035c37706f82')">
            <template #default="{row}"><span>--</span></template>
          </el-table-column>
          <el-table-column :label="h_i18n('dea0bb058b759a0bc368a5aa39587dd6')" width="88">
            <template #default="{row}"><span>--</span></template>
          </el-table-column>
        </el-table>  
        <el-pagination background @current-change="handleTripPageChange"
          v-model:currentPage="tripCurrentPage" :page-size="10" style="display: flex;flex-direction: row;justify-content: flex-end;margin-right:50px;"
          layout="total, prev, pager, next,jumper" :total="tripTotal">
        </el-pagination>
      </div>
    </h-list-page>
  </div>
</template>

<script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

import moment from "moment";
export default {
  data(){
    return{
      specialCurrentPage: 1,
      specialTotal: 0,
      specialTableData:[],
      specialArray:[],
      submitDate:[],
      searchData:{},
      tripTableData:[],
      tripCurrentPage:1,
      tripTotal:0
    }
  },
  methods:{
    h_i18n,
    getLevelTable(){
      this.startLoading(h_i18n('26b5bd4947df8be257c59dde927b400c'))
      this.$http({
        method: "post",
        url: "/base/userevaluation/QualityLevelMidPage",
        data: {
          pageNo:this.specialCurrentPage,
          pageSize: 10,
          supplyCode: this.$route.query.supplyCode||this.$route.query.vCode||this.$route.query.vcode,
          vcode: this.$route.query.supplyCode||this.$route.query.vCode||this.$route.query.vcode,
        },
      }).then((res) => {
        this.closeLoading()
        this.specialTableData = res.data.data.records||[]
        this.specialTotal = res.data.data.total
      }).catch(err=>{
        this.closeLoading()
        this.info(err.data.msg)
      })
    },
    handleSpecialPageChange(val){
      this.specialCurrentPage = val
      this.getLevelTable()
    },
    resetTable(){
      this.searchData.zyh = ''
      this.submitDate = []
    },
    getTripTable(){
      let url = ''
      let param = {...this.searchData}
      if(this.submitDate&&this.submitDate.length>0){
        param.beginDateOne = moment(this.submitDate[0]).format("YYYY-MM-DD 00:00:00")
        param.endDateOne = moment(this.submitDate[1]).format("YYYY-MM-DD 23:59:59")
        url = `/base/userevaluation/QualityLevelBotPageSele`
      }else{
        url = '/base/userevaluation/QualityLevelBotPage'
        param = {}
      }

      this.startLoading(h_i18n('26b5bd4947df8be257c59dde927b400c'))
      this.$http({
        method: "post",
        url: url,
        data: {
          ...param,
          pageNo:this.tripCurrentPage||1,
          pageSize: 10,
          supplyCode: this.$route.query.supplyCode||this.$route.query.vCode||this.$route.query.vcode,
          vcode: this.$route.query.supplyCode||this.$route.query.vCode||this.$route.query.vcode,
        },
      }).then((res) => {
        this.closeLoading()
        this.tripTableData = res.data.data.records||res.data.data.res||[]
        this.tripTotal = res.data.data.total||res.data.data.datanum || 0
        this.getSpecialNum()
      }).catch(err=>{
        this.closeLoading()
        this.info(err.data.msg)
      })
    },
    handleTripPageChange(val){
      if(val){
        this.tripCurrentPage = val
        this.getTripTable()
      }
    },
    getSpecialNum(){
      if(this.submitDate&&this.submitDate.length>0){
        this.searchData.beginDateOne = moment(this.submitDate[0]).format("YYYY-MM-DD 00:00:00")
        this.searchData.endDateOne = moment(this.submitDate[1]).format("YYYY-MM-DD 23:59:59")
      }else{
        this.searchData.beginDateOne = moment(new Date()).format("YYYY-MM-DD 00:00:00")
        this.searchData.endDateOne = moment(new Date()).format("YYYY-MM-DD 23:59:59")
      }
      this.$http({
        method: "post",
        url: "/base/userevaluation/selezyh",
        data: {
          ...this.searchData,
          supplyCode: this.$route.query.supplyCode||this.$route.query.vCode||this.$route.query.vcode,
          vcode: this.$route.query.supplyCode||this.$route.query.vCode||this.$route.query.vcode,
        },
      }).then((res) => {
        this.specialArray = res.data.data||[]
      }).catch(err=>{
        this.info(err.data.msg)
      })
    },
    handleDetail(){
      this.$router.push({
        path: '/specialDetail',
        query: {
          vcode: this.$route.query.supplyCode||this.$route.query.vCode||this.$route.query.vcode,
        }
      })
    },
    handleOrderDetail(){
      this.$router.push({
        path: '/openOrderDetail',
        query: {
          vcode: this.$route.query.supplyCode||this.$route.query.vCode||this.$route.query.vcode,
        }
      })
    },
    handleSubmitDate(val){
      if(val){
        this.submitDate = [...val]
      }else{
        this.submitDate = []
      }
    },
    handleVersion(){
      const vCode = this.$route.query.vcode
      const vName = this.$route.query.vName
      const resourceId = this.$route.query.resourceId
      const roleCode = this.$route.query.roleCode
      const roleId = this.$route.query.roleId
      const name = this.$route.query.name
      const nickName = this.$route.query.nickName
      const trueName = this.$route.query.trueName
      const supplyName = this.$route.query.supplyName
      const userName = this.$route.query.userName
      const dataFrom = this.$route.query.dataFrom
      if (process.env.NODE_ENV != 'production') {
        window.open("https://t-api-cn-sp000339-bridge-i.hwork.haier.net/userevaluation_qualitylevel?vcode="+ vCode+"&vName="+vName+"&resourceId="+resourceId
          +"&roleCode="+roleCode+"&supplyCode="+vCode+"&roleId="+roleId+"&name="+name+"&nickName="+nickName+"&trueName="+trueName+"&supplyName="+supplyName+"&userName="+userName+"&dataFrom="+dataFrom
        )
      }else{
        window.open("https://sqm.haier.net/userevaluation_qualitylevel?vcode="+ vCode+"&vName="+vName+"&resourceId="+resourceId
          +"&roleCode="+roleCode+"&supplyCode="+vCode+"&roleId="+roleId+"&name="+name+"&nickName="+nickName+"&trueName="+trueName+"&supplyName="+supplyName+"&userName="+userName+"&dataFrom="+dataFrom
        )
      }
    }
  },
  mounted(){
    this.getLevelTable()
    this.getTripTable()
    this.getSpecialNum()
  }
}
</script>

<style>
.el-table--border::after, .el-table--group::after{
  width: 0;
}
.haier-list-page .el-table--border, .haier-list-page .haier-list-page .el-table--group{
  border-right: none;
  border-bottom: none;
}
.el-table--border::after, .el-table--group::after, .el-table::before{
  background-color:#e5e6eb !important;
}
.is-hwork .el-table th{
  border-right: 1px solid #e5e6eb !important;
}
.haier-list-page{
  padding: 16px;
}
</style>

<style lang="scss" scoped>
.title-content{
  box-sizing: border-box;
  background: #fff;
  height: 56px;
  line-height: 56px;
  color: #1D2129;
  font-size: 18px;
  padding: 0 16px;
}
.is-hwork{
  width: 100%;
  min-width: 100%;
  box-sizing: border-box;
}
.is-hwork .el-table th{
  background: #F1F2F8 !important;
  color: #1D2129 !important;
  font-size: 14px;
}
.level-container{
  .item-module{
    box-sizing: border-box;
    background: #fff;
    border-radius: 8px;
    padding: 16px 16px 0 16px;
  }
  .title-style{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    color: #1D2129;
    font-weight: bold;
  }
  .btn-container{
    display: flex;
    flex-direction: row;
    margin-top: 16px;
  }
}
.export-btn{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 90px;
  height: 28px !important;
  line-height: 28px !important;
  text-align: center;
  background: #fff;
  border: 1px	solid#C9CDD4;
  color: #1D2129;
  border-radius: 6px;
  font-size: 12px;
  cursor: pointer;
  margin-bottom: 8px;
}
.primary-btn{
  box-sizing: border-box;
  min-width: 60px;
  max-width: 120px;
  height: 30px !important;
  line-height: 30px !important;
  text-align: center;
  background: #fff;
  border: 1px	solid#165DFF;
  color: #165dff;
  border-radius: 6px;
  font-size: 14px;
  padding: 0 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  &:hover{
    background: rgba(22, 93, 255, 0.1);
  }
  &:active{
    color: #0E42D2;
    background: rgba(14, 66, 210, 0.1);
    border: 1px	solid rgb(14, 66, 210);
  }
}
.reset-btn{
  width: 60px;
  height: 30px !important;
  line-height: 30px !important;
  text-align: center;
  background: #fff;
  border: 1px	solid#C9CDD4;
  color: #1D2129;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  &:hover{
    background: rgba(22, 93, 255, 0.1);
  }
  &:active{
    color: #0E42D2;
    background: rgba(14, 66, 210, 0.1);
    border: 1px	solid rgb(14, 66, 210);
  }
}
.marginL12{
  margin-left: 12px;
}
.el-table--border td:first-child .cell, .el-table--border th:first-child .cell{
  padding-left: 14px;
}
body .el-table .cell{
  text-align: left;
}
.el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
  border-right: none;
}
.haier-list-page .el-table tr:nth-child(odd) td{
  background: #fff;
}
.haier-list-page .el-table .cell{
  padding-left: 16px !important;
}
</style>